import { AutogenModelPayee401kRate, AutogenRowPayee401kRate } from "./autogen/AutogenModelPayee401kRate";

export class ModelPayee401kRate extends AutogenModelPayee401kRate<RowPayee401kRate> {
	constructor() {
		super(RowPayee401kRate);
	}
}

export class RowPayee401kRate extends AutogenRowPayee401kRate {
}